import store from '@/store'

/**
 * 检查当前用户是否拥有指定权限
 * @param {string|string[]} value - 权限码或权限码数组（满足其一即可）
 * @returns {boolean}
 */
export function checkPermission(value) {
  var permissions = store.getters.permissions
  if (!permissions || permissions.length === 0) return false
  if (permissions.indexOf('*') !== -1) return true
  if (Array.isArray(value)) {
    return value.some(function(p) { return permissions.indexOf(p) !== -1 })
  }
  return permissions.indexOf(value) !== -1
}
